import { GroupData } from "./Group";

export declare interface StudentData {
	group: string;
	_id: string;
	firstname: string;
	lastname: string;
	username?: string;
	password?: string;
	email: string;
}

export declare interface groupWithStudentCredentials {
	student: StudentCredentials;
	groups: Array<GroupData>;
}

export declare interface StudentCredentials {
	group_id: string,
	student_id: string,
	username: string,
	password: string
}

export const emptyStudent = {
	group: '',
	_id: '',
	firstname: '',
	lastname: '',
	username: '',
	email: ''
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/models/Student.ts